import { render, staticRenderFns } from "./dadosPessoaisAstec.vue?vue&type=template&id=d52a049a&scoped=true"
import script from "./dadosPessoaisAstec.vue?vue&type=script&lang=js"
export * from "./dadosPessoaisAstec.vue?vue&type=script&lang=js"
import style0 from "./dadosPessoaisAstec.vue?vue&type=style&index=0&id=d52a049a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52a049a",
  null
  
)

export default component.exports